/** Rejects item IDs containing `/`.
 *
 * Use as an item component's `validator` when the integration puts the item ID
 * into its own paths or URLs, where a `/` would split it into several segments.
 */
export const pathSegmentIdValidator = async (id: string) =>
  id.includes("/") ? "Identifiers can't contain `/`" : undefined;
